import { render, staticRenderFns } from "./selPackage.vue?vue&type=template&id=2927c125&scoped=true"
import script from "./selPackage.vue?vue&type=script&lang=js"
export * from "./selPackage.vue?vue&type=script&lang=js"
import style0 from "./selPackage.vue?vue&type=style&index=0&id=2927c125&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2927c125",
  null
  
)

export default component.exports